import React, { Component } from 'react';
import AddButton from '../addButton';
import { SaveButton, DeleteButton } from '../modalButtons';

function formatPhone(num) {
    if (!num) return '—';
    var digits = num.replace(/\D/g, '');
    if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
    if (digits.length === 10) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
    return num;
}

var TYPE_COLORS = {
    genesysCloud: { color: '#1a5276', bg: '#eaf3fb' },
    amazonConnect: { color: '#7b341e', bg: '#fef3e8' },
    phoneNumber: { color: '#4a235a', bg: '#f5eef8' },
};

class Queues extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editItem: null,
            isNew: false,
            sortBy: 'name',
            sortOrder: 1,
            loading: false,
            error: ''
        };
    }

    cancel = () => {
        this.setState({ editItem: null, isNew: false, loading: false, error: '' });
    }

    componentWillReceiveProps() {
        if (this.state.loading) this.cancel();
    }

    openNew = () => {
        this.setState({
            editItem: { name: '', businessHoursGroup: '', transferType: ((this.props.data.Queues || {}).transferTypes || [{ id: 'phoneNumber' }])[0].id, phoneNumber: '', queueId: '' },
            isNew: true,
            error: ''
        });
    }

    openEdit = (id) => () => {
        var data = (this.props.data.Queues || {}).data || {};
        var item = data[id];
        if (!item) return;
        this.setState({ editItem: Object.assign({ queueId: '' }, item), isNew: false, error: '' });
    }

    setField = (field) => (e) => {
        var val = e.target.value;
        this.setState(function (s) { return { editItem: Object.assign({}, s.editItem, { [field]: val }) }; });
    }

    save = () => {
        var item = this.state.editItem;
        if (!item.name || !item.name.trim()) { this.setState({ error: 'Name is required.' }); return; }
        var typeQueues = ((this.props.data.Queues || {}).queues || []).filter(function (q) { return q.type === item.transferType; });
        if (typeQueues.length > 0 && !item.queueId) { this.setState({ error: 'Please select a queue.' }); return; }
        if (typeQueues.length === 0 && !item.phoneNumber.trim()) { this.setState({ error: 'Phone number is required.' }); return; }
        this.props.ws.send(JSON.stringify({ route: 'addEditItem', module: 'Queues', item: item }));
        this.setState({ loading: true, error: '' });
    }

    doDelete = () => {
        this.props.ws.send(JSON.stringify({ route: 'deleteItem', module: 'Queues', item: this.state.editItem }));
        this.setState({ loading: true });
    }

    toggleSort = (col) => () => {
        this.setState(function (s) { return { sortBy: col, sortOrder: s.sortBy === col ? -s.sortOrder : 1 }; });
    }

    sortIcon = (col) => {
        return this.state.sortBy === col ? (this.state.sortOrder === 1 ? ' ▲' : ' ▼') : '';
    }

    render() {
        if (!this.props.active) return <div></div>;

        var queuesData = this.props.data.Queues || {};
        var rawData = queuesData.data || {};
        var allQueues = queuesData.queues || [];
        var transferTypes = queuesData.transferTypes || [];
        var bhGroups = (this.props.data.BusinessHours || {}).groups || {};
        var sb = this.state.sortBy, so = this.state.sortOrder;

        var dataArray = Object.keys(rawData).map(function (id) { return rawData[id]; });
        dataArray.sort(function (a, b) {
            var av = (a[sb] || '').toLowerCase(), bv = (b[sb] || '').toLowerCase();
            return av > bv ? so : av < bv ? -so : 0;
        });

        var rows = dataArray.map(function (q) {
            var bhName = bhGroups[q.businessHoursGroup] ? bhGroups[q.businessHoursGroup].name : '—';
            var selectedQueueId = q.queueId;
            var matchedQueue = allQueues.find(function (aq) { return aq.id === selectedQueueId; });
            var transferLabel = matchedQueue ? matchedQueue.name : formatPhone(q.phoneNumber);
            return (
                <tr className="dataRow" key={q.id} onClick={this.openEdit(q.id)} style={{ cursor: 'pointer', alignItems: 'center' }}>
                    <td style={{ width: '280px', flexShrink: 0, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', alignSelf: 'center' }}>{q.name}</td>
                    <td style={{ minWidth: '180px', textAlign: 'left', alignSelf: 'center' }}>{bhName}</td>
                    <td style={{ minWidth: '120px', textAlign: 'left', alignSelf: 'center' }}>
                        {(function () {
                            var typeDef = transferTypes.find(function (t) { return t.id === q.transferType; }) || {};
                            var c = TYPE_COLORS[q.transferType] || TYPE_COLORS.phoneNumber;
                            return (
                                <span style={{
                                    fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px',
                                    color: c.color, background: c.bg, borderRadius: '4px', padding: '2px 7px'
                                }}>
                                    {typeDef.label || q.transferType}
                                </span>
                            );
                        })()}
                    </td>
                    <td style={{ minWidth: '200px', textAlign: 'left', alignSelf: 'center' }}>{transferLabel}</td>
                </tr>
            );
        }.bind(this));

        var modal = null;
        if (this.state.editItem) {
            var item = this.state.editItem;
            modal = (
                <div className="blackout" tabIndex="1" autoFocus>
                    <div className="pop" style={{ display: 'flex', flexDirection: 'column', width: '480px', maxWidth: '96vw', padding: 0, position: 'relative', overflow: 'hidden' }}>
                        <div className="viewCloser" onClick={this.cancel}></div>
                        <div style={{ background: '#002f5f', padding: '20px 28px 14px', color: '#fff', flexShrink: 0 }}>
                            <div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.55)', marginBottom: '4px' }}>
                                {this.state.isNew ? 'New Queue' : 'Edit Queue'}
                            </div>
                            <div style={{ fontSize: '20px', fontWeight: '700' }}>{item.name || 'Queue'}</div>
                        </div>

                        <div style={{ padding: '22px 28px 26px', overflowY: 'auto', maxHeight: 'calc(85vh - 90px)' }}>

                            <label style={labelStyle}>Queue Name</label>
                            <input type="text" value={item.name || ''} onChange={this.setField('name')} placeholder="e.g. Downtown Express Support" style={inputStyle} />

                            <label style={Object.assign({}, labelStyle, { marginTop: '16px' })}>Business Hours Group</label>
                            <select value={item.businessHoursGroup || ''} onChange={this.setField('businessHoursGroup')} style={inputStyle}>
                                <option value="">— None —</option>
                                {Object.keys(bhGroups).map(function (id) {
                                    return <option key={id} value={id}>{bhGroups[id].name}</option>;
                                })}
                            </select>

                            <label style={Object.assign({}, labelStyle, { marginTop: '16px' })}>Transfer Type</label>
                            <select value={item.transferType || ''} onChange={function (e) { this.setState(function (s) { return { editItem: Object.assign({}, s.editItem, { transferType: e.target.value, queueId: '' }) }; }); }.bind(this)} style={Object.assign({}, inputStyle, { marginBottom: '16px' })}>
                                {transferTypes.map(function (type) {
                                    return <option key={type.id} value={type.id}>{type.label}</option>;
                                })}
                            </select>

                            {(function () {
                                var typeQueues = allQueues.filter(function (q) { return q.type === item.transferType; });
                                var typeDef = transferTypes.find(function (t) { return t.id === item.transferType; }) || {};
                                if (typeQueues.length > 0) {
                                    return (
                                        <div>
                                            <label style={labelStyle}>{typeDef.label} Queue</label>
                                            <select value={item.queueId || ''} onChange={this.setField('queueId')} style={inputStyle}>
                                                <option value="">— Select a queue —</option>
                                                {typeQueues.map(function (q) {
                                                    return <option key={q.id} value={q.id}>{q.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                    );
                                }
                                return (
                                    <div>
                                        <label style={labelStyle}>Phone Number</label>
                                        <input type="text" value={item.phoneNumber || ''} onChange={this.setField('phoneNumber')}
                                            placeholder="e.g. +1 (555) 867-5309" style={inputStyle} />
                                    </div>
                                );
                            }.bind(this))()}

                            {this.state.error && <div className="error" style={{ margin: '12px 0' }}>{this.state.error}</div>}

                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                                {!this.state.isNew && <DeleteButton onClick={this.doDelete} />}
                                {this.state.loading ? <div className="loader"></div> : <SaveButton onClick={this.save} />}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div style={{ width: '100%' }}>
                {modal}
                <AddButton onClick={this.openNew} />
                <table style={{ float: 'left', width: '100%' }}>
                    <thead>
                        <tr className="dataRow">
                            <th style={{ width: '280px', flexShrink: 0, cursor: 'pointer', textAlign: 'left' }} onClick={this.toggleSort('name')}>Name{this.sortIcon('name')}</th>
                            <th style={{ minWidth: '180px', textAlign: 'left' }}>Business Hours</th>
                            <th style={{ minWidth: '120px', textAlign: 'left' }}>Type</th>
                            <th style={{ minWidth: '200px', textAlign: 'left' }}>Destination</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length > 0 ? rows : (
                            <tr><td colSpan="4" style={{ padding: '32px', textAlign: 'center', color: '#bbb', fontSize: '14px', fontStyle: 'italic' }}>No queues yet — click the + button to add one.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}

const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: '700', letterSpacing: '1px',
    textTransform: 'uppercase', color: '#888', marginBottom: '8px'
};
const inputStyle = {
    width: '100%', padding: '9px 12px', border: '1px solid #ccc', borderRadius: '6px',
    fontSize: '14px', color: '#222', background: '#fff', boxSizing: 'border-box', marginBottom: '4px'
};

const icon = 'menuHeadset';
const roles = ['View', 'Add', 'Edit', 'Delete'];
export { Queues, icon, roles };
